<template>
    <div class="new-turno">
        <h2 class="title">{{ $t('novo-turno') }}</h2>
        <div class="inputs">
            <label v-text="$t('titulo-turno')" />
            <input class="turno-input" type="text" name="turno-input" v-model="val.descricao" />
        </div>
        <!-- <div class="inputs">
            <label v-text="$t('criar-turno')" />
            <SelectBox :items="allclients" :icons="false" :placeholder="getClients()" />
        </div> -->
        <div class="form-buttons">
            <button class="cancel-btn" type="button">
                {{ $t('cancelar') }}
            </button>
            <button class="save-btn" type="button" @click="saveChanges(val)">
                {{ $t('criar-turno') }}
            </button>
        </div>
    </div>
</template>

<script>
// import SelectBox from '@/components/shared/SelectBox.vue';
import TurnoService from '@/services/TurnoService';

export default {
    props: {
        val: {
            default: {},
        },
    },
    data() {
        return {
            allclients: ['Administrador', 'Gestor', 'Promotor', 'Vendedor'],
            avo: this.$parent.$parent,
        };
    },
    created() {
        this.service = new TurnoService(this.$http, this.$router);
    },
    components: {
        // SelectBox,
    },
    computed: {},
    methods: {
        getClients() {
            if (!this.val.publicar) {
                return '';
            } else {
                return !this.val.publicar;
            }
        },
        saveChanges(value) {
            this.service.save(value).then((v) => {
                this.avo.$emit('update-data', v);
                this.$parent.closeModal();
            });
        },
    },
};
</script>

<style lang="scss" scoped>
// @import "../../../../styles.scss";

.new-turno {
    width: 100%;
    position: relative;

    > h2 {
        font-weight: 600;
        line-height: normal;
        font-size: 31px;

        color: $primary-color;
        margin-left: 20px;
        margin-top: 20px;
        margin-bottom: 20px;
    }

    > .inputs {
        width: 70%;
        position: relative;
        left: 50%;
        transform: translateX(-50%);
        margin-bottom: 20px;

        > label {
            color: $darker-gray-color;
            font-weight: 600;
            line-height: normal;
            font-size: 12px;
            letter-spacing: 0.26px;
        }
    }

    > .form-buttons {
        position: absolute;
        top: -20px;
        right: 0;
        display: flex;
        justify-content: flex-end;

        > .save-btn,
        > .cancel-btn {
            position: relative;
            color: $sovis-white;
            font-size: 12px;
            text-align: center;
            padding: 15px 40px;
            border: none;
            border-radius: 6px;
            font-weight: 600;
            margin-left: 20px;
            @include gradient-button();

            cursor: pointer;
        }

        > .cancel-btn {
            color: $darker-gray-color;
            @include exclude-button();
        }
    }
}
</style>
